import React from 'react';
import './Spotlight.css';

const spotlightItems = [
  {
    id: 1,
    tag: 'Success Story',
    title: '10,000+ Careers Transformed Across IT & Non-IT Sectors',
    image: 'https://static.vecteezy.com/system/resources/thumbnails/003/001/884/small_2x/rpa-robotic-process-automation-innovation-technology-concept-vector.jpg',
    span: 'row-span-2',
  },
  {
    id: 2,
    tag: 'Partnerships',
    title: '500+ Corporate Collaborations Creating Opportunities',
    image: 'https://th.bing.com/th/id/OIP.q3J-9OKF_2Uf_wUtch7wHQAAAA?w=302&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7',
  },
  {
    id: 3,
    tag: 'Awards',
    title: 'Recognized for Excellence in Talent & Training',
    image: 'https://www.pinclipart.com/picdir/big/229-2298060_blue-abstract-lines-png-transparent-image-png-arts.png',
  },
  {
    id: 4,
    tag: 'Recognitions',
    title: 'Top Career Solutions Provider in India',
    image: 'https://th.bing.com/th/id/OIP.hxPw5nWRp_NzAZPq6V_A4AHaCs?w=323&h=127&c=7&r=0&o=5&dpr=1.3&pid=1.7',
  },
  {
    id: 5,
    tag: 'Training',
    title: 'Skill-First Programs Empowering Job Seekers',
    image: 'https://th.bing.com/th/id/OIP.fbJ0ez-xVVgyi0wFysR9iAHaEM?w=286&h=180&c=7&r=0&o=5&dpr=1.3&pid=1.7',
  },
];

const Spotlight = () => {
  return (
    <section className="spotlight-wrapper">
      <h2 className="title">
        In <span className="highlight">The Spotlight</span>
      </h2>

      <div className="grid-layout">
        {spotlightItems.map((item) => (
          <div
            key={item.id}
            className={`card ${item.span || ''} ${item.id === 1 ? 'green-transition-card' : ''}`}
          >
            <img src={item.image} alt={item.title} className="card-img" />
            <span className="tag">{item.tag}</span>
            <div className="card-overlay">
              <h3 className="card-title">{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Spotlight;
